import { createHooks } from 'hookable'

const TicketPayoutHooksManager = createHooks<{
  BeforeTicketPayout: () => Promise<void>
}>()

export { TicketPayoutHooksManager }
